import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-dlt-spinner',
    templateUrl: './dlt-spinner.component.html',
    styleUrls: ['./dlt-spinner.component.scss']
})
export class DltSpinnerComponent implements OnInit {

    @Input() inner = 'Full'; // Inside, Inline
    @Input() text = '';

    _loading = false;

    get loading(): boolean {
        return this._loading;
    }

    @Input('loading')
    set loading(value) {
        this._loading = value;
    }

    @Input() spinnerClassesIdx = 0;
    spinnerClasses = ['spinnerBounce', 'spinnerSketch', 'spinnerSquare', 'spinnerBounce3', 'spinnerCircle'];

    constructor() {
    }

    ngOnInit() {
    }

    nextSpinner() {
        this.spinnerClassesIdx++;
        if (this.spinnerClassesIdx > this.spinnerClasses.length - 1) {
            this.spinnerClassesIdx = 0;
        }
    }
}
